import { Component } from 'react';
import i18n from '../../i18n/index.js';

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // Without this the stack never leaves the render pass and the screen below
    // is all anyone ever sees.
    console.error('Unhandled UI error:', error, info?.componentStack);
  }

  render() {
    if (this.state.hasError) {
      const t = i18n.t.bind(i18n);

      return (
        <div className="grid min-h-screen place-items-center bg-beam-ink px-6 text-white">
          <div className="max-w-lg text-center">
            <p className="text-sm font-semibold uppercase tracking-[0.28em] text-beam-sky">BEAM</p>
            <h1 className="mt-4 font-display text-4xl font-extrabold">{t('errors.title')}</h1>
            <p className="mt-4 text-white/70">{t('errors.body')}</p>
            <div className="mt-8 flex flex-wrap justify-center gap-3">
              <button
                type="button"
                onClick={() => window.location.reload()}
                className="focus-ring inline-flex rounded-lg bg-white px-5 py-3 text-sm font-bold text-beam-ink"
              >
                {t('errors.reload')}
              </button>
              <a
                href="/"
                className="focus-ring inline-flex rounded-lg border border-white/25 px-5 py-3 text-sm font-bold text-white"
              >
                {t('errors.goHome')}
              </a>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
